import { apiPOST } from './api';

export const confirmTodo = (data) => apiPOST('/todo_confirmations', data);

export const removeTodo = (data) => apiPOST('/todo_dismissals', data);
